import { notify, SUCCESS } from "@/template-parts/notices";

jQuery( document.body ).on( 'added_to_cart', function( _e, _fragments, _hash, $button ) {
    const card = $button.get( 0 ).closest( '.product' );
    const title = card?.querySelector( 'h2, .woocommerce-loop-product__title' );
    if ( !title?.textContent ) return;
    notify( `Added ${title.textContent} to basket`, SUCCESS );
} );